import React, { useState } from 'react';

import { Card } from 'antd';
import { cardShadowStyle } from './SharedCard.style';

interface IProps {
  title?: React.ReactNode;
  extra?: React.ReactNode;
  style?: React.CSSProperties;
  customClasses?: string;
  size?: 'default' | 'small' | 'middle';
  hideExtra?: boolean;
  collapsible?: boolean;
  defaultExpanded?: boolean;
  children?: React.ReactNode;
}

const collapsibleTitleStyle: React.CSSProperties = {
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  padding: '4px 0',
  borderRadius: 4,
  transition: 'background-color 0.2s ease',
  width: '100%',
};

export const SharedCard: React.FC<IProps> = ({
  title,
  extra,
  style,
  children,
  customClasses,
  size = 'default',
  hideExtra = false,
  collapsible = false,
  defaultExpanded = true,
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  const cardTitle = collapsible ? (
    <div
      role="button"
      tabIndex={0}
      onClick={() => setExpanded((prev) => !prev)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setExpanded((prev) => !prev);
        }
      }}
      style={collapsibleTitleStyle}
    >
      <div style={{ flex: 1, minWidth: 0 }}>{title}</div>
    </div>
  ) : (
    title
  );

  const collapsedBodyStyle = collapsible && !expanded ? { padding: 0, display: 'none' } : {};

  return (
    <Card
      title={cardTitle}
      extra={hideExtra ? undefined : extra}
      size={size}
      style={{ ...cardShadowStyle, ...style }}
      className={customClasses}
      styles={{ body: collapsedBodyStyle }}
    >
      <div
        style={{
          overflow: 'hidden',
          maxHeight: collapsible && !expanded ? 0 : 5000,
          opacity: collapsible && !expanded ? 0 : 1,
          transition: 'max-height 0.3s ease, opacity 0.2s ease',
        }}
      >
        {children}
      </div>
    </Card>
  );
};
